export function nodeIsString(node) {
  return node && typeof node.valueOf() === 'string';
}
export function renderConfigOrCustom(node, DefaultEl) {
  if (nodeIsString(node)) {
    return DefaultEl;
  }
  return node;
}
export var isWindowDefined = function isWindowDefined() {
  return typeof window !== 'undefined';
};
export var capitalize = function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
export function isLtr(ref) {
  var direction = 'ltr';
  if (ref.current) {
    direction = window.getComputedStyle(ref.current).direction;
  }
  return direction === 'ltr';
}

/**
 * Merges multiple refs into a single ref callback.
 * The merged ref callback can be used to assign a value to multiple refs simultaneously.
 * Heavily inspired by https://github.com/gregberge/react-merge-refs
 *
 * @template T - The type of the HTML element.
 * @param refs - An array of refs to be merged.
 * @returns A ref callback that assigns a value to all the merged refs.
 */

export function mergeRefs(refs) {
  return function (value) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null) {
        ref.current = value;
      }
    });
  };
}